import {useMultiFormContext} from "../../../../../Common/components/MultiForm";
import React, {useEffect, useMemo} from "react";
import {formatStatus} from "../../../../../../util/Helpers";
import Document from "./Document";
import {Col, Nav, Row, Tab} from "react-bootstrap";

export function DocumentTab({dataKey, title, status, src}) {
    return (
        <Nav.Item className={"w-100"}>
            <Nav.Link
                eventKey={dataKey}
                className={`px-0 border-top`}
            >
                <img
                    height={"40px"}
                    width={"40px"}
                    style={{objectFit: "fill"}}
                    src={src}
                    alt={title ?? ""}
                    className={"rounded-lg mr-2"}
                />
                <div className={"px-1 flex-fill"}>{title}</div>
                {formatStatus(status)}
            </Nav.Link>
        </Nav.Item>
    );
}

export function Documents({title, dataKey, initialValues: { docs, cip, kycLevel, status }, isEditable}) {
    const { upsertValue } = useMultiFormContext();

    const pendingDocument = useMemo(() => {
        return docs.some(doc => doc.status === "PENDING");
    }, [docs]);
    
    const isValid = useMemo(() => {
        let pic_id_valid = false;
        let passportValid = false;
        let address_id_valid = false;
    
        for (const document of docs) {
            const isApproved = document.status === "APPROVED";
    
            switch (document.type) {
                case "PICTURE_ID":
                    pic_id_valid = pic_id_valid || isApproved;
                    break;
                case "PASSPORT":
                    passportValid = passportValid || isApproved;
                    break;
                case "PROOF_OF_ADDRESS":
                    address_id_valid = address_id_valid || isApproved;
                    break;
                case "PICTURE_ID_PROOF_OF_ADDRESS":
                    pic_id_valid = pic_id_valid || isApproved;
                    address_id_valid = address_id_valid || isApproved;
                    break;
                default:
                    break;
            }
        }
    
        if (kycLevel === 1 && status === "verified") {
            return pic_id_valid && passportValid && address_id_valid && !pendingDocument;
        }
        return pic_id_valid && passportValid && !pendingDocument;
    }, [docs, kycLevel, status, pendingDocument]);
    
    const validStyle = isValid ? "primary" : "warning"

    let latestDocumentCheck = useMemo(() => {
        return cip.find((result) => result.reportType === "document")
    }, [cip])

    useEffect(() => {
        upsertValue(
            dataKey,
            {
                data: docs,
                isValid
            }
        )
    }, [dataKey, docs, isValid, upsertValue])

    return (
        <Tab.Container id="left-tabs-example" defaultActiveKey={docs[0]?.documentId} className={"h-100"}>
            <Row className={"h-100"}>
                <Col
                    sm={4}
                    className={"d-flex flex-column border-right h-100 overflow-auto"}
                >
                    <h3 className="font-weight-bolder">{title}</h3>
                    <div
                        className={`p-3 mb-3 rounded-sm text-${validStyle} bg-light-${validStyle}`}
                    >
                        {`Both a Picture ID and passport  ${isValid ? "have been" : "must be"} approved for level 1 while a proof of address must be approved for level 2`}
                    </div>
                    <Nav>
                        {docs.map(({documentId, type, status, document}) => (
                            <DocumentTab
                                key={documentId}
                                dataKey={documentId}
                                status={status}
                                src={document}
                                title={type.replaceAll("_", " ").toLowerCase()}
                            />
                        ))}
                    </Nav>
                </Col>
                <Col sm={8} className={"h-100 overflow-auto"}>
                    <Tab.Content className={"h-100"}>
                        {docs.map((doc) => (
                            <Tab.Pane key={doc.documentId} eventKey={doc.documentId} className={"h-100"}>
                                <Document
                                    checkResult={latestDocumentCheck}
                                    initialValues={doc}
                                    isEditable={isEditable}
                                />
                            </Tab.Pane>
                        ))}
                    </Tab.Content>
                </Col>
            </Row>
        </Tab.Container>
    )
}